import type { NativeContextRNProps } from '../props/NativeContextRNProps';

import { getDeviceProperties } from './LoggableDeviceProperties';

import {
    AvroOptional,
    log as signalsLogRNGraphQLError,
} from '@indeed/signals-schema/com/indeed/signals/schema/reactnative/RNGraphQLError';

interface LogGraphQLErrorParams {
    provider: string;
    messages: string[];
    query: string;
    operationName: string;
    variables: string;
    nativeContext?: NativeContextRNProps;
}

export function logGraphQLErrors({
    provider,
    messages,
    query,
    operationName,
    variables,
    nativeContext,
}: LogGraphQLErrorParams): void {
    const { ctk, accountId } = nativeContext ?? {};
    signalsLogRNGraphQLError({
        provider,
        messages,
        query,
        operationName: AvroOptional.string(operationName),
        deviceProperties: getDeviceProperties(),
        variables: AvroOptional.string(variables),
        ctk: AvroOptional.string(ctk),
        accountId: AvroOptional.string(accountId),
    });
}
